// components/Drawer.tsx
import { FC, ReactNode } from "react";

interface DrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
}

const Drawer: FC<DrawerProps> = ({ open, onClose, children, className = "" }) => {
  return (
    <>
      <div
        onClick={onClose}
        className={`fixed inset-0 bg-black bg-opacity-50 transition-opacity duration-300 z-40 ${
          open ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      />

      <div
        className={`fixed top-0 left-0 h-full min-w-fit bg-white shadow-lg transform transition-transform duration-300 ease-in-out z-50  ${
          open ? "translate-x-0" : "-translate-x-full"
        } ${className}`}
      >
        {children}
      </div>
    </>
  );
};

export default Drawer;
